'use client'
import { IconArrowRight, IconMail } from '@tabler/icons-react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const CTAContactLink = () => {
  const pathname = usePathname()

  return (
    pathname !== '/kontakt' && (
      <Link
        href="/kontakt"
        className="fixed top-[300px] lg:top-[200px]
      right-0 flex flex-row items-center gap-x-6 
      p-6 lg:p-8 transition-colors border-t border-b border-l rounded-l-3xl tran
      text-lg leading-6 border-KMRSx24-Orange bg-KMRS-Darkmode hover:bg-KMRSx24-Orange z-[45]
      [&:active]:text-white [&:hover_svg]:text-white [&_svg]:text-KMRSx24-Orange  "
      >
        <IconArrowRight size={24} className="hidden lg:inline" />
        <IconMail size={24} className="lg:hidden" />
        <span className="hidden lg:inline">Projekt starten</span>
        <span className="sr-only">Kontakt aufnehmen</span>
      </Link>
    )
  )
}

export default CTAContactLink
